import circleHouseS from '../components/1elements/Icons/js/mapIcons/circle/circle-houseS'
import circleHouseL from '../components/1elements/Icons/js/mapIcons/circle/circle-houseL'
import circleFlat from '../components/1elements/Icons/js/mapIcons/circle/circle-flat'
import circleHighriseS from '../components/1elements/Icons/js/mapIcons/circle/circle-highriseS'
import circleHighriseM from '../components/1elements/Icons/js/mapIcons/circle/circle-highriseM'
import circleHighriseL from '../components/1elements/Icons/js/mapIcons/circle/circle-highriseL'
import circlePostOffice from '../components/1elements/Icons/js/mapIcons/circle/circle-postOffice'
import circleHospital from '../components/1elements/Icons/js/mapIcons/circle/circle-hospital'
import circleBank from '../components/1elements/Icons/js/mapIcons/circle/circle-bank'
import circleStore from '../components/1elements/Icons/js/mapIcons/circle/circle-store'
import circleRestaurant from '../components/1elements/Icons/js/mapIcons/circle/circle-restaurant'
import circleHotel from '../components/1elements/Icons/js/mapIcons/circle/circle-hotel'
import circleAircraft from '../components/1elements/Icons/js/mapIcons/circle/circle-aircraft'
import circleShip from '../components/1elements/Icons/js/mapIcons/circle/circle-ship'
import circleTrain from '../components/1elements/Icons/js/mapIcons/circle/circle-train'
import circleTruck from '../components/1elements/Icons/js/mapIcons/circle/circle-truck'
import circleBus from '../components/1elements/Icons/js/mapIcons/circle/circle-bus'
import circleCar from '../components/1elements/Icons/js/mapIcons/circle/circle-car'
import circleRadioTower from '../components/1elements/Icons/js/mapIcons/circle/circle-radioTower'
import circleSchool from '../components/1elements/Icons/js/mapIcons/circle/circle-school'
import circleJanitor from '../components/1elements/Icons/js/mapIcons/circle/circle-janitor'
import circleConstruction from '../components/1elements/Icons/js/mapIcons/circle/circle-construction'
import circleTools from '../components/1elements/Icons/js/mapIcons/circle/circle-tools'
import circleDefault from '../components/1elements/Icons/js/mapIcons/circle/circle-default'
import pinHouse from '../components/1elements/Icons/js/mapIcons/pin/pin-house'
import pinFlat from '../components/1elements/Icons/js/mapIcons/pin/pin-flat'
import pinHighriseS from '../components/1elements/Icons/js/mapIcons/pin/pin-highriseS'
import pinHighriseM from '../components/1elements/Icons/js/mapIcons/pin/pin-highriseM'
import pinHighriseL from '../components/1elements/Icons/js/mapIcons/pin/pin-highriseL'
import pinPostOffice from '../components/1elements/Icons/js/mapIcons/pin/pin-postOffice'
import pinHospital from '../components/1elements/Icons/js/mapIcons/pin/pin-hospital'
import pinBank from '../components/1elements/Icons/js/mapIcons/pin/pin-bank'
import pinStore from '../components/1elements/Icons/js/mapIcons/pin/pin-store'
import pinRestaurant from '../components/1elements/Icons/js/mapIcons/pin/pin-restaurant'
import pinHotel from '../components/1elements/Icons/js/mapIcons/pin/pin-hotel'
import pinAircraft from '../components/1elements/Icons/js/mapIcons/pin/pin-aircraft'
import pinShip from '../components/1elements/Icons/js/mapIcons/pin/pin-ship'
import pinTrain from '../components/1elements/Icons/js/mapIcons/pin/pin-train'
import pinTruck from '../components/1elements/Icons/js/mapIcons/pin/pin-truck'
import pinBus from '../components/1elements/Icons/js/mapIcons/pin/pin-bus'
import pinCar from '../components/1elements/Icons/js/mapIcons/pin/pin-car'
import pinRadioTower from '../components/1elements/Icons/js/mapIcons/pin/pin-radioTower'
import pinSchool from '../components/1elements/Icons/js/mapIcons/pin/pin-school'
import pinJanitor from '../components/1elements/Icons/js/mapIcons/pin/pin-janitor'
import pinConstruction from '../components/1elements/Icons/js/mapIcons/pin/pin-construction'
import pinTools from '../components/1elements/Icons/js/mapIcons/pin/pin-tools'
import pinDefault from '../components/1elements/Icons/js/mapIcons/pin/pin-default'
import pinHouseL from '../components/1elements/Icons/js/mapIcons/pin/pin-houseL'
import flagHouseS from '../components/1elements/Icons/js/mapIcons/flag/flag-houseS'
import flagHouseL from '../components/1elements/Icons/js/mapIcons/flag/flag-houseL'
import flagFlat from '../components/1elements/Icons/js/mapIcons/flag/flag-flat'
import flagHighriseS from '../components/1elements/Icons/js/mapIcons/flag/flag-highriseS'
import flagHighriseM from '../components/1elements/Icons/js/mapIcons/flag/flag-highriseM'
import flagHighriseL from '../components/1elements/Icons/js/mapIcons/flag/flag-highriseL'
import flagPostOffice from '../components/1elements/Icons/js/mapIcons/flag/flag-postOffice'
import flagHospital from '../components/1elements/Icons/js/mapIcons/flag/flag-hospital'
import flagBank from '../components/1elements/Icons/js/mapIcons/flag/flag-bank'
import flagStore from '../components/1elements/Icons/js/mapIcons/flag/flag-store'
import flagRestaurant from '../components/1elements/Icons/js/mapIcons/flag/flag-restaurant'
import flagHotel from '../components/1elements/Icons/js/mapIcons/flag/flag-hotel'
import flagAircraft from '../components/1elements/Icons/js/mapIcons/flag/flag-aircraft'
import flagShip from '../components/1elements/Icons/js/mapIcons/flag/flag-ship'
import flagTrain from '../components/1elements/Icons/js/mapIcons/flag/flag-train'
import flagTruck from '../components/1elements/Icons/js/mapIcons/flag/flag-truck'
import flagBus from '../components/1elements/Icons/js/mapIcons/flag/flag-bus'
import flagCar from '../components/1elements/Icons/js/mapIcons/flag/flag-car'
import flagRadioTower from '../components/1elements/Icons/js/mapIcons/flag/flag-radioTower'
import flagSchool from '../components/1elements/Icons/js/mapIcons/flag/flag-school'
import flagJanitor from '../components/1elements/Icons/js/mapIcons/flag/flag-janitor'
import flagConstruction from '../components/1elements/Icons/js/mapIcons/flag/flag-construction'
import flagTools from '../components/1elements/Icons/js/mapIcons/flag/flag-tools'
import flagDefault from '../components/1elements/Icons/js/mapIcons/flag/flag-default'
import proximityHouseS from '../components/1elements/Icons/js/mapIcons/proximity/proximity-houseS'
import proximityHouseL from '../components/1elements/Icons/js/mapIcons/proximity/proximity-houseL'
import proximityFlat from '../components/1elements/Icons/js/mapIcons/proximity/proximity-flat'
import proximityHighriseS from '../components/1elements/Icons/js/mapIcons/proximity/proximity-highriseS'
import proximityHighriseM from '../components/1elements/Icons/js/mapIcons/proximity/proximity-highriseM'
import proximityHighriseL from '../components/1elements/Icons/js/mapIcons/proximity/proximity-highriseL'
import proximityPostOffice from '../components/1elements/Icons/js/mapIcons/proximity/proximity-postOffice'
import proximityHospital from '../components/1elements/Icons/js/mapIcons/proximity/proximity-hospital'
import proximityBank from '../components/1elements/Icons/js/mapIcons/proximity/proximity-bank'
import proximityStore from '../components/1elements/Icons/js/mapIcons/proximity/proximity-store'
import proximityRestaurant from '../components/1elements/Icons/js/mapIcons/proximity/proximity-restaurant'
import proximityHotel from '../components/1elements/Icons/js/mapIcons/proximity/proximity-hotel'
import proximityAircraft from '../components/1elements/Icons/js/mapIcons/proximity/proximity-aircraft'
import proximityShip from '../components/1elements/Icons/js/mapIcons/proximity/proximity-ship'
import proximityTrain from '../components/1elements/Icons/js/mapIcons/proximity/proximity-train'
import proximityTruck from '../components/1elements/Icons/js/mapIcons/proximity/proximity-truck'
import proximityBus from '../components/1elements/Icons/js/mapIcons/proximity/proximity-bus'
import proximityCar from '../components/1elements/Icons/js/mapIcons/proximity/proximity-car'
import proximityRadioTower from '../components/1elements/Icons/js/mapIcons/proximity/proximity-radioTower'
import proximitySchool from '../components/1elements/Icons/js/mapIcons/proximity/proximity-school'
import proximityJanitor from '../components/1elements/Icons/js/mapIcons/proximity/proximity-janitor'
import proximityConstruction from '../components/1elements/Icons/js/mapIcons/proximity/proximity-construction'
import proximityTools from '../components/1elements/Icons/js/mapIcons/proximity/proximity-tools'
import proximityDefault from '../components/1elements/Icons/js/mapIcons/proximity/proximity-default'

export const mapIconListForGoogleMap = (fillColor, style, hover) => {
    const formattedFillColor = fillColor.replace("#", "%23");
    switch(style){
        case 'circle':
            return([
                circleHouseS(formattedFillColor, hover),
                circleHouseL(formattedFillColor, hover),
                circleFlat(formattedFillColor, hover),
                circleHighriseS(formattedFillColor, hover),
                circleHighriseM(formattedFillColor, hover),
                circleHighriseL(formattedFillColor, hover),

                circlePostOffice(formattedFillColor, hover),
                circleHospital(formattedFillColor, hover),
                circleBank(formattedFillColor, hover),
                circleStore(formattedFillColor, hover),
                circleRestaurant(formattedFillColor, hover),
                circleHotel(formattedFillColor, hover),

                circleAircraft(formattedFillColor, hover),
                circleShip(formattedFillColor, hover),
                circleTrain(formattedFillColor, hover),
                circleTruck(formattedFillColor, hover),
                circleBus(formattedFillColor, hover),
                circleCar(formattedFillColor, hover),

                circleRadioTower(formattedFillColor, hover),
                circleSchool(formattedFillColor, hover),
                circleJanitor(formattedFillColor, hover),
                circleConstruction(formattedFillColor, hover),
                circleTools(formattedFillColor, hover),
                circleDefault(formattedFillColor, hover),
            ])
        case 'pin':
            return([
                pinHouse(formattedFillColor, hover),
                pinHouseL(formattedFillColor, hover),
                pinFlat(formattedFillColor, hover),
                pinHighriseS(formattedFillColor, hover),
                pinHighriseM(formattedFillColor, hover),
                pinHighriseL(formattedFillColor, hover),

                pinPostOffice(formattedFillColor, hover),
                pinHospital(formattedFillColor, hover),
                pinBank(formattedFillColor, hover),
                pinStore(formattedFillColor, hover),
                pinRestaurant(formattedFillColor, hover),
                pinHotel(formattedFillColor, hover),

                pinAircraft(formattedFillColor, hover),
                pinShip(formattedFillColor, hover),
                pinTrain(formattedFillColor, hover),
                pinTruck(formattedFillColor, hover),
                pinBus(formattedFillColor, hover),
                pinCar(formattedFillColor, hover),

                pinRadioTower(formattedFillColor, hover),
                pinSchool(formattedFillColor, hover),
                pinJanitor(formattedFillColor, hover),
                pinConstruction(formattedFillColor, hover),
                pinTools(formattedFillColor, hover),
                pinDefault(formattedFillColor)
            ])
        case 'flag':
            return([
                flagHouseS(formattedFillColor, hover),
                flagHouseL(formattedFillColor, hover),
                flagFlat(formattedFillColor, hover),
                flagHighriseS(formattedFillColor, hover),
                flagHighriseM(formattedFillColor, hover),
                flagHighriseL(formattedFillColor, hover),

                flagPostOffice(formattedFillColor, hover),
                flagHospital(formattedFillColor, hover),
                flagBank(formattedFillColor, hover),
                flagStore(formattedFillColor, hover),
                flagRestaurant(formattedFillColor, hover),
                flagHotel(formattedFillColor, hover),

                flagAircraft(formattedFillColor, hover),
                flagShip(formattedFillColor, hover),
                flagTrain(formattedFillColor, hover),
                flagTruck(formattedFillColor, hover),
                flagBus(formattedFillColor, hover),
                flagCar(formattedFillColor, hover),

                flagRadioTower(formattedFillColor, hover),
                flagSchool(formattedFillColor, hover),
                flagJanitor(formattedFillColor, hover),
                flagConstruction(formattedFillColor, hover),
                flagTools(formattedFillColor, hover),
                flagDefault(formattedFillColor)
            ])
        default:
            return([
                proximityHouseS(formattedFillColor, hover),
                proximityHouseL(formattedFillColor, hover),
                proximityFlat(formattedFillColor, hover),
                proximityHighriseS(formattedFillColor, hover),
                proximityHighriseM(formattedFillColor, hover),
                proximityHighriseL(formattedFillColor, hover),

                proximityPostOffice(formattedFillColor, hover),
                proximityHospital(formattedFillColor, hover),
                proximityBank(formattedFillColor, hover),
                proximityStore(formattedFillColor, hover),
                proximityRestaurant(formattedFillColor, hover),
                proximityHotel(formattedFillColor, hover),

                proximityAircraft(formattedFillColor, hover),
                proximityShip(formattedFillColor, hover),
                proximityTrain(formattedFillColor, hover),
                proximityTruck(formattedFillColor, hover),
                proximityBus(formattedFillColor, hover),
                proximityCar(formattedFillColor, hover),

                proximityRadioTower(formattedFillColor, hover),
                proximitySchool(formattedFillColor, hover),
                proximityJanitor(formattedFillColor, hover),
                proximityConstruction(formattedFillColor, hover),
                proximityTools(formattedFillColor, hover),
                proximityDefault(formattedFillColor, hover)
            ])
    }

}
